import React from 'react';
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";

// Images
import logo from "../../images/logo_all_white.png";


const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 0 auto'
  },
  logo: {
    position: 'fixed',
    top: 0,
    left: 0,
    padding: '20px',
    '& img': {
      height: '65px'
    }
  },
  bkg: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    backgroundColor: '#91a0ac',
    background: 'linear-gradient(to bottom right, #ca8edd, #003049)',
    
    backgroundSize: 'cover',
    transform: 'scale(1.1)',
    overflow: 'hidden',
    filter: 'blur(3px)'
  },
  box: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    padding: '50px',
    // paddingBottom: '40px',
    margin: '20px',
    borderRadius: '20px',
    backdropFilter: 'blur(10px)',
    boxShadow: '9px 3px 30px 0px rgba(0,0,0,0.1)',
    width: '27%',
    '@media (max-width: 780px)' : {
      width: '90%',
      margin: '0',
      height: '90%',
      top: '100px'
    }
  }
});

const FullPageBkg = (props) => {
  const classes = useStyles();

  return(
    <div className={classes.root}>

      {/* Background Image */}
      <div className={classes.bkg} />

      <div className={classes.logo}>
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Content Box */}
      <div className={classes.box}>
        {props.children}
      </div>
    </div>
  )
}

export default FullPageBkg;
